// Payloads for RTable row operations, and their format validators.
//
// An RTable is a nested RObject living on a scoped projection of its
// RTableGroup's DAG. Row ops do not carry the table name: the group-level
// envelope (see ../rtable_group/payload.ts) tags entries with the table, the
// same way nested RSet element ops don't repeat their elementHash.
//
// Preconditions (FKs and restrictions) live only in the schema: validators
// derive them from the declaration plus the op's row values and enforce them
// whether or not the op mentions them; they are never serialized in payloads.
//
// v1 semantics is drop-on-void: views filter ops whose derived preconditions
// are voided; there is no general meaning reinterpretation.
import { json } from "@hyper-hyper-space/hhs3_json";
import { MAX_NAME_LENGTH, MAX_COLUMNS, MAX_HASH_LENGTH, MAX_KEY_ID_LENGTH, MAX_SIGNATURE_LENGTH, } from "../rschema/payload.js";
export const MAX_UUID_LENGTH = 128;
export const insertRowFormat = {
    action: [json.Type.Constant, 'insert'],
    rowId: [json.Type.BoundedString, MAX_HASH_LENGTH],
    uuid: [json.Type.BoundedString, MAX_UUID_LENGTH],
    values: [json.Type.BoundedMap, [json.Type.BoundedString, MAX_NAME_LENGTH], json.Type.Something, MAX_COLUMNS],
    author: [json.Type.Option, [json.Type.BoundedString, MAX_KEY_ID_LENGTH]],
    signature: [json.Type.Option, [json.Type.BoundedString, MAX_SIGNATURE_LENGTH]],
};
export const updateRowFormat = {
    action: [json.Type.Constant, 'update'],
    rowId: [json.Type.BoundedString, MAX_HASH_LENGTH],
    values: [json.Type.BoundedMap, [json.Type.BoundedString, MAX_NAME_LENGTH], json.Type.Something, MAX_COLUMNS],
    author: [json.Type.Option, [json.Type.BoundedString, MAX_KEY_ID_LENGTH]],
    signature: [json.Type.Option, [json.Type.BoundedString, MAX_SIGNATURE_LENGTH]],
};
export const deleteRowFormat = {
    action: [json.Type.Constant, 'delete'],
    rowId: [json.Type.BoundedString, MAX_HASH_LENGTH],
    author: [json.Type.Option, [json.Type.BoundedString, MAX_KEY_ID_LENGTH]],
    signature: [json.Type.Option, [json.Type.BoundedString, MAX_SIGNATURE_LENGTH]],
};
